import { render, staticRenderFns } from "./the-email-dialog.vue?vue&type=template&id=23d4c588&scoped=true&"
import script from "./the-email-dialog.vue?vue&type=script&lang=js&"
export * from "./the-email-dialog.vue?vue&type=script&lang=js&"
import style0 from "./the-email-dialog.vue?vue&type=style&index=0&id=23d4c588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d4c588",
  null
  
)

export default component.exports